<template>
  <v-dialog
    scrollable
    v-model="dialog"
    width="90%"
    @close="close"
    persistent
  >
    <v-card>
      <v-btn
        fab
        @click="close"
        class="btnClose"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-text class="pt-5">
        <component
          v-if="route"
          :is="route.component"
          :in-dialog="true"
          :in-dialog-params="routeParams"
        ></component>
      </v-card-text>

      <v-divider></v-divider>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "GlobalDialog",
  computed: {
    dialog: {
      get() {
        return this.$store.state.dialog.isVisible
      },
      set(v) {
        this.$store.commit("dialog/setIsVisible", v)
      }
    },
    routeParams() {
      if (!this.$store.state.dialog.route) return null
      return this.$store.state.dialog.route.params
    },
    route() {
      if (!this.$store.state.dialog.route) return null

      return this.$router.options.routes.find(r => r.name === this.$store.state.dialog.route.name)
    }
  },
  methods: {
    close() {
      this.$store.commit("dialog/setIsVisible", false)
      setTimeout(() => {
        this.$store.commit("dialog/clearRoute")
      }, 100)
    }
  }
}
</script>

<style scoped>
button.btnClose {
  position: absolute;
  top: 25px;
  right: 35px;
  z-index: 999;
}
</style>
